import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { OrganisationDetails } from 'app/shared/models/org-details.model';

import { ClientHeaderService } from './../client-header.service';

@Component({
    selector: 'app-review-company',
    templateUrl: './review-company.component.html'
})

/**
 * Component to update review date.
 */
export class ReviewCompanyComponent implements OnInit {
    reviewCompanyForm: FormGroup;
    organisationDetails: OrganisationDetails;
    savingDate: boolean;

    formErrors = {
        'reviewDate': '',
    };

    validationMessages = {
        'reviewDate': {
            'required': 'Required field value.',
        },
    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private formBuilder: FormBuilder,
        private clientHeaderService: ClientHeaderService,
        private snackBarService: SnackBarService) { }

    ngOnInit() {
        this.createForm();
        this.updateReviewCompanyForm();
    }

    createForm() {
        this.reviewCompanyForm = this.formBuilder.group({
            reviewDate: ['', Validators.required],
        });

        this.reviewCompanyForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.reviewCompanyForm) {
            return;
        }
        const form = this.reviewCompanyForm;
        for (const field in this.formErrors) {
            if (this.formErrors.hasOwnProperty(field)) {
                // clear previous error message (if any)
                this.formErrors[field] = '';
                const control = form.get(field);
                if (control && control.touched && !control.valid) {
                    const messages = this.validationMessages[field];
                    for (const key in control.errors) {
                        if (control.errors.hasOwnProperty(key)) {
                            this.formErrors[field] += messages[key] + ' ';
                        }
                    }
                }
            }
        }
    }

    updateReviewCompanyForm(): void {
        if (this.organisationDetails) {
            const date = new Date(this.organisationDetails.clientVO.reviewDate);
            this.reviewCompanyForm.patchValue({
                reviewDate: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
            });
        }
    }

    onSubmit({ value, valid }) {
        const oldDate = new Date(this.organisationDetails.clientVO.reviewDate);
        const newDate = new Date(value.reviewDate);
        this.savingDate = true;
        const postOrgData = {
            'clientId': this.organisationDetails.organisationVO.clientId,
            'reviewDate': newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()
        };
        this.clientHeaderService
            .updateReviewDate(postOrgData).subscribe(response => {
                this.savingDate = false;
                if (response.flagResult) {
                    this.dialogRef.close(newDate.getTime());
                }
                this.callSnackBarService(response,
                    MessageService.UPDATE_REVIEW_DATE_SUCCESS,
                    MessageService.UPDATE_REVIEW_DATE_FAILURE);
            },
            err => {
                this.savingDate = false;
                this.callSnackBarService(err,
                    MessageService.UPDATE_REVIEW_DATE_SUCCESS,
                    MessageService.UPDATE_REVIEW_DATE_FAILURE);
            });
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/reviewcompany/review-company.component.ts